<template>
	<div class="confirmation-panel">
		<!-- 问题文本 -->
		<div class="question-text">{{ panelData.question }}</div>

		<!-- 选项按钮 (type为options或both时) -->
		<div v-if="showOptions" class="options-container">
			<el-button
				v-for="option in panelData.options"
				:key="option.value"
				size="small"
				@click="selectOption(option.value)">
				{{ option.label }}
			</el-button>
		</div>

		<!-- 文本输入 (type为text_input或both时) -->
		<div v-if="showTextInput" class="text-input-container">
			<el-input
				v-model="inputText"
				:placeholder="panelData.placeholder || '请输入回答'"
				type="textarea"
				:rows="2"
				maxlength="500"
				show-word-limit
			/>
			<el-button
				type="primary"
				size="small"
				@click="submitText"
				:disabled="!canSubmitText">
				提交
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ConfirmationPanel',
	props: {
		panelData: {
			type: Object, // ConfirmationPanel: { question, type, options?, placeholder?, required }
			required: true
		}
	},
	data() {
		return {
			inputText: ''
		}
	},
	computed: {
		// 是否显示选项按钮
		showOptions() {
			const type = this.panelData.type;
			return type === 'options' || type === 'both';
		},

		// 是否显示文本输入框
		showTextInput() {
			const type = this.panelData.type;
			return type === 'text_input' || type === 'both';
		},

		// 文本是否可提交
		canSubmitText() {
			return this.inputText.trim().length > 0;
		}
	},
	methods: {
		// 选择选项
		selectOption(value) {
			this.$emit('submit', {
				type: 'option',
				value
			});
		},

		// 提交文本
		submitText() {
			if (!this.canSubmitText) return;

			this.$emit('submit', {
				type: 'text',
				value: this.inputText.trim()
			});

			// 清空输入
			this.inputText = '';
		}
	}
}
</script>

<style scoped lang="scss">
.confirmation-panel {
	padding: 12px;
	background: #f5f7fa;
	border-radius: 6px;
	border: 1px dashed #dcdfe6;
	margin-top: 8px;

	.question-text {
		font-size: 14px;
		color: #303133;
		margin-bottom: 12px;
		font-weight: 500;
		line-height: 1.5;
	}

	.options-container {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 8px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.text-input-container {
		display: flex;
		flex-direction: column;
		gap: 8px;

		.el-button {
			align-self: flex-end;
		}
	}
}
</style>
